import { createSlice } from '@reduxjs/toolkit';

import { BrowserUrlConsts } from '@lib/core/service/consts';

export const initialState = {
  [BrowserUrlConsts.currentDateDay]: null,
};

export const QAParameterSlice = createSlice({
  initialState,
  name: 'QAParameterSlice',
  reducers: {
    updateCurrentDateParams: (state, action) => {
      state[BrowserUrlConsts.currentDateDay] = action.payload;
    },
  },
});

export default QAParameterSlice.reducer;
export const { updateCurrentDateParams } = QAParameterSlice.actions;
